/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  BuilderFormStateSchema,
  BuilderUserContext, FormRootSchema,
  FormState, FormStateSchema,
  whenCreateOrEditMode,
} from '@gh/builder-shared';
import { BuilderPermission, SalesFolderStatus } from '@gh/builder-shared-data';
import { FormGroupSchemaConfig, NumberTypes, TextTypes, updateSchemaWithChildren } from '@gh/common-shared';
import { FormMode, isControlDirty } from '@gh/core-ui';
import { RfqGeneral } from '../../../resources/lead.model';

@Injectable()
export class RfqGeneralTabFormState extends FormState<RfqGeneral> {
  constructor(schemaFactory: BuilderFormSchemaFactory,
              private userContext: BuilderUserContext) {
    super(schemaFactory);
  }

  get submitValue(): RfqGeneral {
    const { group } = this;

    return {
      ...group.value,
      isParagraph1Changed: isControlDirty(group, 'paragraph1'),
      isParagraph2Changed: isControlDirty(group, 'paragraph2'),
      isValidDaysChanged: isControlDirty(group, 'validDays'),
    };
  }

  updateForm(): void {
    updateSchemaWithChildren(this.group, this.getFormSchemaConfig(this.group.getRawValue()));
  }

  protected buildSchema(general: RfqGeneral, { root }: FormStateSchema): FormRootSchema {
    const mode = this.userContext.hasPermission(BuilderPermission.Sales.Leads.EDIT) &&
    general.status === SalesFolderStatus.Active ? FormMode.EditMode : FormMode.ViewMode;

    return root({
      enabled: whenCreateOrEditMode(),
      mode,
      ...this.getFormSchemaConfig(general),
    });
  }

  private getFormSchemaConfig(general: RfqGeneral): FormGroupSchemaConfig {
    return {
      children: {
        salesFolderId: void 0,
        owner1: { required: true },
        owner2: { required: general.isSigner2 },
        owner3: { required: general.isSigner3 },
        email1: { required: general.isSigner1, type: TextTypes.Email },
        email2: { required: general.isSigner2, type: TextTypes.Email },
        email3: { required: general.isSigner3, type: TextTypes.Email },
        isSigner1: void 0,
        isSigner2: void 0,
        isSigner3: void 0,
        showOn: void 0,
        description: void 0,
        validDays: { type: NumberTypes.Days },
        paragraph1: void 0,
        paragraph2: void 0,
        memo: void 0,
      },
    };
  }
}
